// extracted by mini-css-extract-plugin
export default {"panel":"panel-index-fJfiR","title":"title-index-SygAV","text":"text-index-gtiOt","panelContent":"panelContent-index-mxfvl"};